import React, { useEffect, useState } from "react";
import "./event.css";
import Footer from "../Footer/Footer";
import EventHeader from "./EventHeader";
import EventNav from "./EventNav";
import { useNavigate } from "react-router-dom";

const Event: React.FC = () => {
  const [activePopup, setActivePopup] = useState<number | null>(null);
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const handleGetInTouch = () => {
    if (window.location.pathname === "/") {
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const contactSection = document.getElementById("contact");
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  useEffect(() => {
    const faders = document.querySelectorAll(".fade-in");

    const appearOptions = {
      threshold: 0.2,
      rootMargin: "0px 0px -200px 0px",
    };

    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("show");
        observer.unobserve(entry.target);
      });
    }, appearOptions);

    faders.forEach((fader, index) => {
      const el = fader as HTMLElement;
      el.style.transitionDelay = `${index * 0.03}s`;
      appearOnScroll.observe(el);
    });
  }, []);

  // 🔹 Workshop adatok (ISO dátum formátummal)
  // A leírás bekezdésekre bontva (paragraphs), az előadó és a meta-adatok külön mezőkben,
  // hogy a popup-ban strukturáltan, két hasábban tudjuk megjeleníteni.
  const workshops = [
    {
      id: 1,
      img: "kate.jpg",
      short: "5 November  2026 – 9am to 4.30pm via Zoom (6.5 CPD hours)",
      fees: "$250 + GST",
      title:
        "Gender-Based Violence in Higher Education: Assessing Risk and Responding Therapeutically",
      paragraphs: [
        "The National Code in relation to Gender Based Violence has prioritised the need for a comprehensive, trauma-informed, consistent and defensible approach to the assessment and management of risk in relation to Gender Based Violence in higher education institutions.",
        "This workshop will assist participants in developing a clear understanding of the core principles behind assessing and managing risk in cases of gender-based violence. It will cover the process of risk assessment and the trauma-informed approaches to working with both disclosers and responders in this complex and challenging landscape.",
        "Participants will also be introduced to a new platform to assist assessors in understanding and conceptualising risks in their cases, whilst also formulating clear, informed and defensible plans to manage any risks identified.",
      ],
      presenter:
        "Presented by Dr. Chelsey Dewson and Dr. Katie Seidler, both forensic psychologists with decades of experience working as experts in the field of sexual, gender-based and intimate-partner violence.",
      meta: {
        date: "5 November 2026",
        time: "9am – 4.30pm",
        format: "Zoom",
        cpd: "6.5 hours",
      },
      date: "2026-11-05",
      
    },
    {
      id: 2,
      img: "secondevent.jpg",
      title:
        "Introduction to Gender-based Violence Risk Assessment & Decision-making Tool for Higher Education (GRAD-E)",
      short: "24 November 2026 – 11am – 1pm via Zoom",
      fees:"Free",
      paragraphs: [
        "GRAD-E has been developed to support universities and higher education providers, including accommodation providers, to identify, assess and respond to gender-based violence risk in a structured, consistent and defensible way. Developed by forensic psychologists with extensive experience in conducting risk assessments, GRAD-E translates complex risk principles into a practical tool designed specifically for the higher education environment and align with the National Higher Education Code to Prevent and Respond to Gender-based Violence 2025.",
        "GRAD-E helps practitioners move beyond simply identifying that risk exists. It provides a structured framework for considering relevant risk factors, understanding the circumstances contributing to risk, identifying protective factors, and supporting proportionate, evidence-informed decision-making.Whether responding to an individual disclosure, assessing an emerging concern, or reviewing ongoing risk, GRAD-E provides a common framework to support assessment, decision-making, risk management and documentation, while helping organisations meet their responsibilities under the Code.",
        "",
      ],
      presenter:
        "Facilitated by Dr. Chelsey Dewson, Director, Threat Advisory Group.",
      meta: {
        date: "24 November 2026",
        time: "11am – 1pm",
        format: "Zoom",
        cpd: "2 hours",
      },
      date: "2026-11-24",
      
    },
  ];

  // 🔹 Csak a jövőbeli workshopok megjelenítése
  const today = new Date();
  const upcomingWorkshops = workshops.filter(
    (w) => new Date(w.date) >= today
  );

  const activeWorkshop = upcomingWorkshops.find((w) => w.id === activePopup);

  return (
    <>
      <EventNav />
      <EventHeader />
      <div className="event-container">
        {/* Bemutató szöveg */}
        <div className="event-intro">
          <h2 className="event-h2 fade-in">Upcoming Workshops</h2>
          <p className="fade-in">
            Understanding the risk and threat associated with human behaviour is
            a unique, dynamic and developing area of professional practice in
            which TAG has leading expertise. TAG strives to promote safety and
            security through human risk identification, assessment, mitigation
            and management. In early 2026, TAG will be offering two online
            professional development workshops aimed at mental health clinicians
            (psychologists, counsellors, clinical case workers etc) working in
            educational settings in better understanding and responding to
            gender based violence.
          </p>
        </div>

        {/* Workshop kártyák */}
        <div className="event-grid fade-in">
          {upcomingWorkshops.length > 0 ? (
            upcomingWorkshops.map((workshop) => (
              <div
                key={workshop.id}
                className="event-card fade-in"
                onClick={() => setActivePopup(workshop.id)}
              >
                <img
                  src={workshop.img}
                  alt={workshop.title}
                  className="event-img"
                />
                <h3>{workshop.title}</h3>
                <p>{workshop.short}</p>
                <p className="event-fee-tag">{workshop.fees}</p>
              </div>
            ))
          ) : (
            <p className="fade-in no-workshops">
              No upcoming workshops at the moment.
            </p>
          )}
        </div>

        {/* Árlista */}
        {upcomingWorkshops.length > 0 && (
          <div className="event-fees fade-in">
            <h3>Fees:</h3>
           <p>Prices vary by workshop. Click on the desired event for details.</p>
          </div>
        )}

        {/* Kapcsolat */}
        <div className="footer-question">
          <h2 className="question fade-in">Need more information?</h2>
          <h2 className="text fade-in">
            For further information or to register, contact:
            <br />
            <a href="mailto:admin@threatadvisorygroup.com" className="email">
              admin@threatadvisorygroup.com
            </a>
          </h2>
        </div>

        {/* Popup ablak */}
        {activeWorkshop && (
          <div className="popup-overlay" onClick={() => setActivePopup(null)}>
            <div className="popup" onClick={(e) => e.stopPropagation()}>
              <button
                className="popup-close"
                onClick={() => setActivePopup(null)}
              >
                ×
              </button>

              <h3 className="popup-title">{activeWorkshop.title}</h3>

              <div className="popup-columns">
                {activeWorkshop.paragraphs.map((para, i) => (
                  <p key={i} className="popup-paragraph">
                    {para}
                  </p>
                ))}
              </div>

              <p className="popup-presenter">{activeWorkshop.presenter}</p>

              <div className="popup-meta">
                <span>
                  <strong>Date:</strong> {activeWorkshop.meta.date}
                </span>
                <span>
                  <strong>Time:</strong> {activeWorkshop.meta.time}
                </span>
                <span>
                  <strong>Format:</strong> {activeWorkshop.meta.format}
                </span>
                <span>
                  <strong>CPD:</strong> {activeWorkshop.meta.cpd}
                </span>
                <span>
                  <strong>Fee:</strong> {activeWorkshop.fees}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Event;
